import type { ComponentType } from 'react';
import type { Role } from '@/types/shared';
import { AdminDashboardGrid } from '@/pages/dashboard/AdminDashboardGrid';
import { PlaceholderDashboardWidgets } from '@/pages/dashboard/PlaceholderDashboardWidgets';

/**
 * Role -> widget-set component (T85). `DashboardPage` renders the shared page `<h1>` and then
 * whatever this registry resolves for the current user's role. Admin gets the real T81/T82
 * widget grid; every other role keeps the existing placeholder unchanged. Adding a role's own
 * widget set later is exactly one entry here — no structural rework of `DashboardPage` or this
 * registry's shape.
 */
const DASHBOARD_WIDGETS_BY_ROLE: Partial<Record<Role, ComponentType>> = {
  Admin: AdminDashboardGrid,
};

export function dashboardWidgetsForRole(role: Role | undefined): ComponentType {
  const widget = role ? DASHBOARD_WIDGETS_BY_ROLE[role] : undefined;
  return widget ?? PlaceholderDashboardWidgets;
}
